import React from 'react';
import { Card, ContentCard, Line, Video } from "../../Common";

function Features() {
  return (
    <Line
      title="Наш конёк—индивидуальный подход"
      secondary="Наша автошкола создана специально для тех, кто привык к индивидуальному подходу в обучении"
    >
      <Card>
        <ContentCard
          title="Гибкое расписание"
          description="Мы подстраиваемся под каждого клиента"
        >
          <Video src="/images/giphy.mp4" />
        </ContentCard>
      </Card>
      <Card>
        <ContentCard
          title="Опытные педагоги"
          description="Наши преподаватели—специалисты с большим водительским и преподавательским стажем"
        >
          <Video src="/images/giphy1.mp4" />
        </ContentCard>
      </Card>
      <Card>
        <ContentCard
          title="Рассрочка платежа"
          description="Оплату за обучение можно произвести в течение всего срока обучения (но небольшой аванс обязателен)"
        >
          <Video src="/images/giphy6.mp4" />
        </ContentCard>
      </Card>
    </Line>
  );
}

export default Features;



// WEBPACK FOOTER //
// ./src/components/About/Common/Features.jsx